// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"9391ce59","193":"ec02f60d","447":"4f380fe6","537":"3ec615d3","775":"db51e482","787":"441f6461"}[chunkId] + ".chunk.js";
};